module.exports = __webpack_public_path__ + "img/1.420ffb88.jpg";